import { render, staticRenderFns } from "./new_jxfw.vue?vue&type=template&id=fe7a18ae&scoped=true"
import script from "./new_jxfw.vue?vue&type=script&lang=js"
export * from "./new_jxfw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7a18ae",
  null
  
)

export default component.exports